<template>
  <div class="user-info" :class="{ 'compact': compact }">
    <span class="user-avatar"><img :src="avatarText" width="32px" height="32px"> </span>
    <span v-if="!compact" class="user-name">{{ userName }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'
 import { cookieHelper } from "@/common/CookieHelper";
const userName = cookieHelper.getCookie("username")  ||  cookieHelper.getCookie("telPhone") ;;
 const avatarText = cookieHelper.getCookie("avatar")  ||'';;
 
</script>

<style scoped>
.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f0f7ff;
  padding: 10px 16px;
  border-radius: 40px;
  transition: all 0.2s;
}

.user-info.compact {
  padding: 6px 12px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: #0066cc;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  flex-shrink: 0;
}

.user-name {
  color: #1e4870;
  font-size: 0.95rem;
  white-space: nowrap;
}
</style>